import type { Services } from '@/services/contracts'
import { httpAdminService } from '@/services/http/admin'
import { httpAuthService } from '@/services/http/auth'
import { httpMcpConsentService } from '@/services/http/mcp'
import { httpPreferencesService } from '@/services/http/preferences'
import { httpReconcileService } from '@/services/http/reconcile'
import { httpRealtimeService } from '@/services/http/realtime'
import { httpReportsService } from '@/services/http/reports'
import { httpSystemService } from '@/services/http/system'

export const httpServices: Services = {
  auth: httpAuthService,
  reports: httpReportsService,
  system: httpSystemService,
  admin: httpAdminService,
  realtime: httpRealtimeService,
  preferences: httpPreferencesService,
  reconcile: httpReconcileService,
  mcpConsent: httpMcpConsentService,
}
